var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 67.75a9.382 9.382 0 01-2.636 6.54A8.879 8.879 0 0140 77a8.879 8.879 0 01-6.364-2.71A9.382 9.382 0 0131 67.75c0-2.453.948-4.806 2.636-6.54A8.879 8.879 0 0140 58.5c2.387 0 4.676.975 6.364 2.71A9.382 9.382 0 0149 67.75zM49 40a9.382 9.382 0 01-2.636 6.54A8.879 8.879 0 0140 49.25a8.879 8.879 0 01-6.364-2.71A9.382 9.382 0 0131 40c0-2.453.948-4.806 2.636-6.54A8.879 8.879 0 0140 30.75c2.387 0 4.676.975 6.364 2.71A9.382 9.382 0 0149 40zm-9-18.5a8.879 8.879 0 006.364-2.71A9.382 9.382 0 0049 12.25a9.382 9.382 0 00-2.636-6.54A8.879 8.879 0 0040 3a8.879 8.879 0 00-6.364 2.71A9.382 9.382 0 0031 12.25c0 2.453.948 4.806 2.636 6.54A8.879 8.879 0 0040 21.5z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default ForwardRef;